export function formatRelativeTime(timestamp: string): string {
    const now = new Date();
    const date = new Date(timestamp);
    const diffMs = now.getTime() - date.getTime();
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffWeeks = Math.floor(diffDays / 7);
    const diffMonths = Math.floor(diffDays / 30);

    if (diffMinutes < 1) return "just now";
    if (diffMinutes < 60) return `${diffMinutes}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    if (diffWeeks < 5) return `${diffWeeks}w ago`;
    if (diffMonths < 12) return `${diffMonths}mo ago`;
    return `${Math.floor(diffMonths / 12)}y ago`;
}

export function getResourceTypeColor(type: string): string {
    switch (type.toLowerCase()) {
        case "link":
            return "#7c4dff";
        case "content":
            return "#00bcd4";
        default:
            return "#2196f3";
    }
}

export function getResourceTypeLabel(type: string): string {
    switch (type.toLowerCase()) {
        case "link":
            return "LINK";
        case "content":
            return "DOCUMENT";
        default:
            return type.toUpperCase();
    }
}
